import { Label } from "@ui/label"

interface FormLabelProps {
    htmlFor?: string
    required?: boolean
    children: React.ReactNode | React.ReactNode[]
}
export function FormLabel({ htmlFor, required, children }: Readonly<FormLabelProps>) {
    return (
        <label htmlFor={htmlFor}>
            {children}
            {required && <sup style={{ color: "red " }}>*</sup>}
        </label>
    )
}

interface FormHelperProps {
    children: React.ReactNode | React.ReactNode[]
}
export function FormHelper({ children }: Readonly<FormHelperProps>) {
    return <Label className="mt-2 text-start font-light">{children}</Label>
}

interface FormErrorProps {
    children: React.ReactNode | React.ReactNode[]
}
export function FormError({ children }: Readonly<FormErrorProps>) {
    return <Label className="text-start font-light text-red">{children}</Label>
}
